<template>
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7782 1.77818L8 9.55635L0.221824 1.77817L1.63604 0.36396L8 6.72792L14.364 0.363962L15.7782 1.77818Z"
        :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChervonIcon',

  props: {
    fill: {
      type: String,
      default: '#fff'
    },
  },
};
</script>